import { CaseField } from "@/types"
import { UserRole } from "@/types/caseUser"
import { FieldTypeId } from "@/types/fieldTypes"

export default class caseFieldValidation {
	static fieldRequired (field: CaseField) {
		if (field.noViewAccess) return false

		if (typeof (field.value) === "string" && field.value.trim() === "") return true

		if (field.field.dataType?.toLowerCase() === FieldTypeId.UserRole) {
			const hasSubroles = !!field.field.extensions?.hasSubroles

			if (!hasSubroles) {
				if (field.value != null && field.value.users != null && field.value.users.length === 0) {
					return true
				}
			} else {
				// Find any subRole user. If none exist, then the field is required as the UserRole objects in the subRoles array must exist but be empty
				const subRolesWithUsers = field.value?.subRoles.find((x: UserRole) => x.users != null && x.users.length > 0)
				if (!subRolesWithUsers) return true
			}
		}

		if (Array.isArray(field.value) && field.value.length === 0) return true

		return !(field.value != null && field.value !== false && field.value !== "")
	}
}
